import { LineItem } from '../LineItem';
import { ShipOrderLineItem } from '../ShipOrderLineItem';

import { IConsolidatedShipmentLineItem } from './IConsolidatedShipmentLineItem';

const TYPE = 'ConsolidatedShipment';

export class ConsolidatedShipmentLineItem extends LineItem {
  id = undefined;
  shipOrderId?: number;
  shipOrderLineItemId?: number;

  constructor(opts?: Partial<LineItem>) {
    super(opts);
    this.type = TYPE;
    this.id = undefined;

    if (opts) {
      const newOpts = opts as ConsolidatedShipmentLineItem;
      if (newOpts?.shipOrderId != null) {
        this.shipOrderId = newOpts.shipOrderId;
      }
      if (newOpts?.shipOrderLineItemId != null) {
        this.shipOrderLineItemId = newOpts.shipOrderLineItemId;
      }
    }
  }

  static build(
    opts: {
      shipOrderId: number;
      shipOrderLineItemId: number;
      pickupStopSequenceNumber: number;
      dropOffStopSequenceNumber: number;
    },
    shipOrderLineItem: ShipOrderLineItem,
  ): ConsolidatedShipmentLineItem {
    const lineItem = new ConsolidatedShipmentLineItem(shipOrderLineItem);

    lineItem.shipOrderId = opts.shipOrderId;
    lineItem.shipOrderLineItemId = opts.shipOrderLineItemId;
    lineItem.pickupStopSequenceNumber = opts.pickupStopSequenceNumber;
    lineItem.dropOffStopSequenceNumber = opts.dropOffStopSequenceNumber;
    return lineItem;
  }

  static isConsolidatedShipmentLineItem(
    lineItem?: LineItem,
  ): lineItem is ConsolidatedShipmentLineItem {
    return lineItem?.type === TYPE;
  }

  toJSON(): IConsolidatedShipmentLineItem {
    if (!this.pickupStopSequenceNumber) {
      throw new Error('Missing pickupStopSequenceNumber');
    }
    if (!this.dropOffStopSequenceNumber) {
      throw new Error('Missing dropOffStopSequenceNumber');
    }
    if (!this.shipOrderLineItemId) {
      throw new Error('Missing shipOrderLineItemId');
    }

    return {
      pickupStopSequenceNumber: this.pickupStopSequenceNumber,
      dropOffStopSequenceNumber: this.dropOffStopSequenceNumber,
      shipOrderLineItemId: this.shipOrderLineItemId,
    };
  }
}
